module.exports = __webpack_public_path__ + "img/strategy_ub_grey.d3485a87.svg";